import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export function regexValidator(nameRe: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const regex = new RegExp(nameRe); // Convert string to RegExp object
    const matches = regex.test(control.value);
    return matches ? null : { regexValidator: { value: control.value } };
  };
}

